export default __webpack_public_path__ + "static/media/codeclimate.ac159d4d.svg";